import React from 'react';
import {InputLabel} from '@material-ui/core';

class InputComponent extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const {value, placeholder, icon, label, onChange, disabled, type, pattern} = this.props;
        return (
            <>
                {label &&
                <InputLabel className='mb-0 color-primary font-13'>
                    {label}
                </InputLabel>
                }
                <div className="input-style has-icon input-style-1 input-required">
                    {icon && <i className={`input-icon fa fa-${icon} color-theme`}></i>}
                    {type && type == "text-area" ?
                        <textarea pattern={pattern} placeholder={placeholder} disabled={disabled}
                               onChange={onChange} value={value}/>
                        :
                        <input type={type || "name"} pattern={pattern} placeholder={placeholder} disabled={disabled}
                               onChange={onChange} value={value}/>
                    }
                </div>
            </>
        );
    }
}

export default InputComponent;